const _ = (data: any) => {
  return data.products.map((product: any, index: number) => {
    return {
      name: `${product.manufacturerCode}  ${product.productNumber}`,
      id: `${product.manufacturerCode}  ${product.productNumber}`,
      price: product.partnerPrice,
      brand: product.manufacturerCode,
      list: data.list,
      position: index + 1
    };
  });
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data);
  return {
    event,
    ecommerce: {
      list: data.list,
      listCriteria: data.listCriteria,
      listPage: data.listPage || 1,
      impressions: [...dataLayerObject]
    }
  };
};
